import React, { Fragment, useState } from 'react'
import { DatePicker } from 'antd'
import { appDate } from 'utils'
import moment, { Moment } from 'moment'

export interface AppDateProps {
  value?: string
  onChange?: (value: any, text: string) => void
  format?: string
  placeholder?: string
  readonly?: boolean
}


export const AppDate = (props: AppDateProps) => {
  const [value, setValue] = useState(appDate.moment(props.value))

  const hanldChange = (newValue: Moment, returnValue: string) => {
    setValue(newValue);
    props.onChange && props.onChange(value, returnValue);
  }

  return (
    <div style={{ width: '100%' }} className="app-date">
      <DatePicker
        onChange={hanldChange}
        placeholder={props.placeholder}
        value={value}
        style={{ width: '100%' }}
        disabled={props.readonly || false}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppDate.tsx